export const environment = {
  production: true,
  apiUrl: "https://heemetal-api.smartskills.ovh/api",
};
